








import { Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'XToDoWizard',
    components: {},
})
export default class XToDoWizard extends Vue {
    private next() {
        this.$router.push({
            name: 'XToDosList',
            query: {
                referrer: 'projects',
            },
        });
    }
}
